import { CoopSummaryResponse, Message, MessageFilter } from '@aipb/gulliver/personal-content/model';
import { uniqueId } from '@aipb/shared/util/other';
import { selectLoading, setLoading, withLoading } from '@aipb/shared/util/state';
import { Injectable } from '@angular/core';
import { createStore, select, setProps, withProps } from '@ngneat/elf';
import { selectAllEntities, setEntities, withEntities } from '@ngneat/elf-entities';
import { isAfter, sub } from 'date-fns';
import { map } from 'rxjs/operators';

export type ActiveFilters = Record<string, string[]>;

interface MessageProps {
  filters: MessageFilter[];
  activeFilters: ActiveFilters;
  coopSummary: CoopSummaryResponse;
}

@Injectable()
export class MessageRepository {
  store = createStore(
    { name: 'personal-content-message-' + uniqueId() },
    withLoading(),
    withEntities<Message>(),
    withProps<MessageProps>({
      filters: [],
      activeFilters: {},
      coopSummary: null
    })
  );

  loading$ = this.store.pipe(selectLoading());

  messages$ = this.store.pipe(selectAllEntities());
  onlineUsers$ = this.messages$.pipe(
    map((messages) => [
      ...new Map(
        messages
          .filter((message) => {
            const date = new Date(message.structured.datetime);

            return isAfter(date, sub(Date.now(), { minutes: 10 }));
          })
          .map((message) => message.structured.sender)
          .map((sender) => sender)
          .map((sender) => [sender['id'], sender])
      ).values()
    ])
  );
  filters$ = this.store.pipe(select((state) => state.filters));
  activeFilters$ = this.store.pipe(select((state) => state.activeFilters));

  coopSummary$ = this.store.pipe(select((state) => state.coopSummary));

  setLoading(loading: boolean) {
    this.store.update(setLoading(loading));
  }

  setMessages(data: Message[]) {
    this.store.update(setEntities(data));
  }

  setActiveFilters(activeFilters: ActiveFilters) {
    this.store.update(
      setProps({
        activeFilters
      })
    );
  }

  setFilters(filters: MessageFilter[]) {
    this.store.update(
      setProps({
        filters
      })
    );
  }

  setCoopSummary(coopSummary: CoopSummaryResponse) {
    this.store.update((state) => ({
      ...state,
      coopSummary
    }));
  }
}
